import Axios from "axios";
import AxiosConfig from "src/utilities/AxiosConfig";
import type { ProfitCenterDispatchRule } from "../types/rules.types";

export const RulesAPI = {
	getErrorMessage: (error: any): string => {
		if (error && typeof error === "object" && "response" in error) {
			// The request was made and the server responded with a status code
			// that falls out of the range of 2xx (https://axios-http.com/docs/handling_errors)

			return `${(error.response?.data as any)?.ErrorMessage}`;
		}

		if (error && typeof error === "object" && "request" in error) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser (https://axios-http.com/docs/handling_errors)

			return "Network error: No response from server";
		}

		return "Unexpected error occurred";
	},

	getDispatchRules: async () => {
		try {
			const response = await Axios.get(
				`${process.env.REACT_APP_API_URL}/api/portal-dispatch/rules`,
				AxiosConfig.configValue(),
			);
			return response.data.Data;
		} catch (error: unknown) {
			const message = RulesAPI.getErrorMessage(error);
			throw new Error(message);
		}
	},

	createDispatchRule: async (
		rule: ProfitCenterDispatchRule,
	): Promise<boolean> => {
		try {
			await Axios.post(
				`${process.env.REACT_APP_API_URL}/api/portal-dispatch/create-rule`,
				rule,
				AxiosConfig.configValue("min"),
			);
		} catch (error: unknown) {
			const message = RulesAPI.getErrorMessage(error);
			throw new Error(message);
		}
		return true;
	},

	getProfitCenters: async (includeInactive: boolean = false) => {
		try {
			const response = await Axios.get(
				`${process.env.REACT_APP_API_URL}/api/portal-dispatch/profit-centers?includeInactive=${includeInactive}`,
				AxiosConfig.configValue(),
			);
			return response.data.Data;
		} catch (error: unknown) {
			const message = RulesAPI.getErrorMessage(error);
			throw new Error(message);
		}
	},

	getRuleTypes: async (includeInactive: boolean = false) => {
		try {
			const response = await Axios.get(
				`${process.env.REACT_APP_API_URL}/api/portal-dispatch/rule-types?includeInactive=${includeInactive}`,
				AxiosConfig.configValue(),
			);
			return response.data.Data;
		} catch (error: unknown) {
			const message = RulesAPI.getErrorMessage(error);
			throw new Error(message);
		}
	},

	editDispatchRule: async (
		rule: ProfitCenterDispatchRule,
	): Promise<boolean> => {
		try {
			await Axios.post(
				`${process.env.REACT_APP_API_URL}/api/portal-dispatch/edit-rule`,
				rule,
				AxiosConfig.configValue("min"),
			);
		} catch (error: unknown) {
			const message = RulesAPI.getErrorMessage(error);
			throw new Error(message);
		}
		return true;
	},

	deleteDispatchRule: async (
		profitCenterDispatchRuleId: number,
	): Promise<boolean> => {
		console.log("test");
		try {
			await Axios.post(
				`${process.env.REACT_APP_API_URL}/api/portal-dispatch/delete-rule?id=${profitCenterDispatchRuleId}`,
				null,
				AxiosConfig.configValue("min"),
			);
		} catch (error: unknown) {
			const message = RulesAPI.getErrorMessage(error);
			throw new Error(message);
		}
		return true;
	},
};
